import {
    GETMAPPEDLISTFORADMIN_SUCCESS,
    GETMAPPEDLISTFORADMIN_FAILED,
    RESET_GETMAPPEDLISTFORADMIN,
    LOADING_GETMAPPEDLISTFORADMIN,
    NETWORK_ERROR_GETMAPPEDLISTFORADMIN
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETMAPPEDLISTFORADMIN:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case GETMAPPEDLISTFORADMIN_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case GETMAPPEDLISTFORADMIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_GETMAPPEDLISTFORADMIN:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_GETMAPPEDLISTFORADMIN:
            return (state = initialState);
        default:
            return state;
    }
};
